import { render, staticRenderFns } from "./info-card.vue?vue&type=template&id=18f48ff2&scoped=true"
import script from "./info-card.vue?vue&type=script&lang=js"
export * from "./info-card.vue?vue&type=script&lang=js"
import style0 from "./info-card.vue?vue&type=style&index=0&id=18f48ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f48ff2",
  null
  
)

export default component.exports